export default __webpack_public_path__ + "static/media/1 (3).93ee77a0.png";